import './BubbleShape.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var bubble = '_hctkb34-3-5-0';
export var bubbleBorder = '_hctkb33-3-5-0';
export var bubbleOutline = _7a468({defaultClassName:'_hctkb30-3-5-0',variantClassNames:{active:{true:'_hctkb31-3-5-0',false:'_hctkb32-3-5-0'}},defaultVariants:{},compoundVariants:[]});